// Central GSAP setup. Import gsap / ScrollTrigger / useGSAP from here so the
// plugins are registered exactly once for the whole app.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, useGSAP);

export { gsap, ScrollTrigger, useGSAP };
